import React from 'react';
import { Sparkles, RefreshCw } from 'lucide-react';

export default function UpdateNotification({ onUpdate, count = 0 }) {
    return (
        <div className="fixed bottom-6 right-6 z-50 animate-in slide-in-from-bottom-10 fade-in duration-700">
            <button
                onClick={onUpdate}
                className="group relative flex items-center gap-4 p-4 rounded-xl border border-white/20 bg-blue-900/60 backdrop-blur-md shadow-2xl hover:bg-blue-800/70 transition-all duration-500 overflow-hidden"
            >
                {/* Efeito de Brilho (Gradient Overlay) */}
                <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform duration-1000" />

                {/* Ícone com fundo brilhante */}
                <span className="relative inline-flex h-10 w-10 items-center justify-center rounded-full bg-blue-500/20 ring-1 ring-blue-400/30 group-hover:scale-110 transition-transform duration-300">
                    <Sparkles className="h-5 w-5 text-blue-200 animate-pulse" />
                </span>

                <div className="text-left">
                    <p className="text-sm font-bold text-white leading-none mb-1 flex items-center gap-2">
                        Novas Atualizações
                        <span className="flex h-2 w-2 rounded-full bg-green-400 animate-ping" />
                    </p>
                    <p className="text-xs text-blue-200 font-medium">
                        Clique para atualizar a visualização
                    </p>
                </div>

                <RefreshCw className="h-5 w-5 text-white/50 group-hover:rotate-180 transition-transform duration-700 ml-2" />
            </button>
        </div>
    );
}
